import React, { Component } from "react";
import {
  Paper,
  TextField,
  Subheader,
  Divider,
  FlatButton,
  AutoComplete,
} from "material-ui";
import Formsy from "formsy-react";
import {
  FormsyText,
  FormsyAutoComplete,
  FormsyRadioGroup,
  FormsyRadio,
  FormsySelect,
} from "formsy-material-ui/lib";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import FormsyDate from "../forms/formComponents/FormsyDate";
import formatDate from "../../../utils/formatDate";

class ScrubSheet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: {
        name: "",
        address: "",
        cityState: "",
      },
      vendor: {
        name: "",
        address: "",
        cityState: "",
      },
      employee: {
        name: "",
      },
      surgeryDate: {},
      customerNumber: "",
      PONumber: "",
      purchasingPhone: "",
      purchasingFax: "",
      items: [],
      customers: [],
      vendors: [],
      employees: [],
      itemSelections: [],
      itemSearchtext: "",
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
      },
    };

    this.addItem = this.addItem.bind(this);
    this.setItem = this.setItem.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentWillMount() {
    let url = `/api/intacct/customers`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ customers: json });
      });

    url = `/api/intacct/vendors`;
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ vendors: json });
      });

    url = `/api/intacct/employees`;
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ employees: json });
      });

    url = `/api/intacct/items`;
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ itemSelections: json });
      });
  }

  submitForm(data) {
    // alert(JSON.stringify(data, null, 4));
    let url = "/api/intacct/scrubsheet";
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
      body: JSON.stringify({ data, jwt: this.props.token.jwt }),
    };
    fetch(url, options);
  }

  notifyFormError(data) {
    console.error("Form error:", data);
  }

  addItem(item) {
    let { items } = this.state;
    if (item) {
      items.push(item);
    } else {
      items.push({
        itemID: "",
        name: "",
        productlineID: "",
        itemType: "",
      });
    }
    this.setState({ items: items, itemSearchtext: "" });
  }

  setItem(item, i) {
    let { items } = this.state;
    items.splice(i, 1, item);
    this.setState({ items: items });
  }

  removeItem(i) {
    let items = this.state.items;
    items.splice(i, 1);
    this.setState({ items: items });
  }

  renderItem(item, i) {
    let { listItemStyle, listStyle, listPaperStyle, centerStyle } =
      this.state.styles;
    return (
      <Paper style={listPaperStyle} key={i}>
        <Subheader>{`Item ${i + 1}`}</Subheader>
        <div style={listStyle}>
          <FormsyAutoComplete
            required
            fullWidth
            name={`items[${i}][itemID]`}
            floatingLabelText="Item ID"
            hintText="Type item ID to find item"
            filter={AutoComplete.caseInsensitiveFilter}
            maxSearchResults={15}
            dataSource={this.state.itemSelections}
            onNewRequest={(item) => {
              this.setItem(item, i);
            }}
            dataSourceConfig={{ text: "itemID", value: "itemID" }}
            searchText={item.itemID}
            value={item.itemID}
          />
          <FormsyAutoComplete
            required
            fullWidth
            name={`items[${i}][name]`}
            floatingLabelText="name"
            hintText="Type name to find item"
            filter={AutoComplete.caseInsensitiveFilter}
            maxSearchResults={15}
            dataSource={this.state.itemSelections}
            onNewRequest={(item) => {
              this.setItem(item, i);
            }}
            dataSourceConfig={{ text: "name", value: "name" }}
            searchText={item.name}
            value={item.name}
          />
          <FormsyText
            required
            fullWidth
            style={listItemStyle}
            name={`items[${i}][productlineID]`}
            floatingLabelText="productlineID"
            value={item.productlineID}
          />
          <FormsyText
            required
            fullWidth
            style={listItemStyle}
            name={`items[${i}][itemType]`}
            floatingLabelText="itemType"
            value={item.itemType}
          />
        </div>
        <center>
          <FlatButton
            style={centerStyle}
            label="Remove"
            hoverColor="#e57373"
            onClick={this.removeItem.bind(this, i)}
          />
        </center>
      </Paper>
    );
  }

  render() {
    if (this.props.isloading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let { centerStyle } = this.state.styles;
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
        >
          <Formsy.Form
            ref="form"
            onValidSubmit={this.submitForm}
            onInvalidSubmit={this.notifyFormError}
          >
            <div style={centerStyle}>
              <h1 style={{ marginBottom: "1em" }}>Sales Order Form</h1>
            </div>
            <Divider />
            <Subheader>Customer</Subheader>
            <div style={centerStyle}>
              <FormsyAutoComplete
                required
                fullWidth
                name="customer"
                floatingLabelText="Hospital"
                filter={AutoComplete.caseInsensitiveFilter}
                maxSearchResults={15}
                dataSource={this.state.customers}
                onNewRequest={(customer) => {
                  this.setState({ customer: customer });
                }}
                dataSourceConfig={{ text: "name", value: "customerID" }}
                searchText={this.state.customer.name}
                value={this.state.customer.name}
              />
              <FormsyText
                name="customerAddress"
                floatingLabelText="Address"
                fullWidth={true}
                required
                hintText=""
                value={this.state.customer.address}
              />
              <FormsyText
                name="customerCityState"
                floatingLabelText="City, State"
                fullWidth={true}
                required
                hintText=""
                value={this.state.customer.cityState}
              />
            </div>
            <Divider />
            <Subheader>Distributor</Subheader>
            <div style={centerStyle}>
              <FormsyAutoComplete
                required
                fullWidth
                name="vendor"
                floatingLabelText="Distributor"
                filter={AutoComplete.caseInsensitiveFilter}
                maxSearchResults={15}
                dataSource={this.state.vendors}
                onNewRequest={(vendor) => {
                  this.setState({ vendor: vendor });
                }}
                dataSourceConfig={{ text: "name", value: "vendorID" }}
                searchText={this.state.vendor.name}
                value={this.state.vendor.name}
              />
              <FormsyText
                name="vendorAddress"
                floatingLabelText="Address"
                fullWidth={true}
                required
                hintText=""
                value={this.state.vendor.address}
              />
              <FormsyText
                name="vendorLocation"
                floatingLabelText="City, State"
                fullWidth={true}
                required
                hintText=""
                value={this.state.vendor.cityState}
              />
            </div>
            <Divider />
            <Subheader>Surgery Details</Subheader>
            <div style={centerStyle}>
              <FormsyAutoComplete
                required
                fullWidth
                name="employee"
                floatingLabelText="Surgeon"
                filter={AutoComplete.caseInsensitiveFilter}
                maxSearchResults={15}
                dataSource={this.state.employees}
                dataSourceConfig={{ text: "name", value: "employeeID" }}
                searchText={this.state.employee.name}
                value={this.state.employee.name}
              />
              <FormsyDate
                name="surgeryDate"
                required
                fullWidth={true}
                firstDayOfWeek={0}
                formatDate={(date) => formatDate(date)}
                hintText="Date surgery was performed"
                floatingLabelText="Date Of Surgery"
                value={this.state.surgeryDate}
              />
            </div>
            <Divider />
            <Subheader>Purchase Details</Subheader>
            <div style={centerStyle}>
              <FormsyText
                name="customerNumber"
                floatingLabelText="Customer Number"
                fullWidth={true}
                hintText=""
                value={this.state.customerNumber}
              />
              <FormsyText
                name="PONumber"
                floatingLabelText="P.O. Number"
                fullWidth={true}
                hintText="Purchase Order number"
                value={this.state.PONumber}
              />
              <FormsyText
                name="purchasingPhone"
                floatingLabelText="Purchasing Phone"
                fullWidth={true}
                hintText=""
                value={this.state.purchasingPhone}
              />
              <FormsyText
                name="purchasingFax"
                floatingLabelText="Purshasing Fax"
                fullWidth={true}
                hintText=""
                value={this.state.purchasingFax}
              />
            </div>
            <Divider />
            <Subheader>Items</Subheader>
            <div style={centerStyle}>
              {this.state.items.map(this.renderItem)}
              <FlatButton
                label="Add item"
                hoverColor="#BDBDBD"
                onClick={this.addItem}
              />
            </div>
            <Divider />
            <div style={centerStyle}>
              <div className="col-sm-6">
                <FlatButton
                  backgroundColor="#A5D6A7"
                  hoverColor="#81C784"
                  style={{ marginTop: "2em", marginBottom: "1em" }}
                  label="Submit"
                  type="submit"
                />
              </div>
              <div className="col-sm-6">
                <FlatButton
                  backgroundColor="#E0E0E0"
                  hoverColor="#BDBDBD"
                  style={{ marginTop: "2em", marginBottom: "1em" }}
                  label="Cancel"
                />
              </div>
            </div>
          </Formsy.Form>
        </Paper>
      );
    }
  }
}

export default ScrubSheet;



// WEBPACK FOOTER //
// ./app/components/IntegrityImplants/ScrubSheet.js